import React, { Component } from 'react';

import DesignerBase from './designer-base/DesignerBase';

import Console from '../../lib/debug';

import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as DesignerState from '../../state/reducer/designer/designer';
import * as ProgramTypes from '../../state/reducer/calendar/programTypes';

export default class AthleteDesignerView extends Component {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentDidUpdate() {
        this.loadCalendarData(this.props);
    }

    loadCalendarData(props) {
        const athleteId = parseInt(props.match.params.athleteId, 10);
        const year = parseInt(props.match.params.year, 10);
        const month = parseInt(props.match.params.month, 10);

        // This has to happen prior to setting the Designer Info because
        // it can wipe out the information that setInfo below sets.
        CalendarState.loadAthleteCalendar(athleteId, year, month);

        DesignerState.setInfo(
            ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
            props.match.params
        );
    }

    render() {
        Console.render('AthleteDesignerView');
        return <DesignerBase />;
    }
}
